//import MercadoPagoConfirm from "../views/shopping_cart/MercadoPagoConfirm";

export const CheckoutRouter = [
  {
    path: '/checkout',
    name: 'Checkout',
    meta: { layout: 'ChuspicLayout' },
    component: () => import('../../views/shopping_cart/Checkout')
  },
  {
    path: '/checkout/thank-you',
    name: 'Checkout.ThankYou',
    component: () => import('../../views/shopping_cart/ThankYou')
  },
  {
    path: '/checkout/pending-order',
    name: 'Checkout.PendingOrder',
    component: () => import('../../views/shopping_cart/PendingOrder'),
  },    
  {
    path: '/checkout/paypal-confirmation',
    name: 'Checkout.PaypalConfirm',
    component: () => import('../../views/shopping_cart/PaypalConfirm')
  },
  {
    path: '/checkout/pending-oxxo',
    name: 'Checkout.PendingOxxo',
    component: () => import('../../views/shopping_cart/PendingOxxo')
  },
  //{
  //path: '/checkout/mercado-pago-confirmation',
  //name: 'Checkout.MercadoPagoConfirm',
  //component: MercadoPagoConfirm
  //},  
];